// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1n2Nl","unreadBadge":"styles_unreadBadge__1007V","modalContent":"styles_modalContent__1mHOI","modal":"styles_modal__1Odm6"};